import {
  BookAppointmentRequest,
  BookAppointmentResponse,
  com,
  IBookAppointmentResponse,
  IClientServiceProto,
  space
} from "./compiled";
import React, {useEffect, useState} from "react";
import {SendRpc} from "../util";

// TODO I think this is just a horrible hack to get it into rollup
import {useAuth0} from "@auth0/auth0-react";
import {com} from "../../dist";
import {RpcState} from "../util/RpcState";
import IProviderBioProto = space.kenko.proto.IProviderBioProto;
import CapturePaymentRequest = com.onkensu.platform.billing.CapturePaymentRequest;


// This gets passed along in the router
type Props = {
  businessId: string,
  provider: IProviderBioProto,
  service: IClientServiceProto,
  locationId: string,
  isVirtual: boolean,
  appointmentTime: number,
  onComplete: (response: IBookAppointmentResponse) => void,
  sessionId: string, // stripe
}

/**
 * Auto-sends an RPC to book the thing.
 */
export const ConfirmBooking = (props: Props) => {

  const [rpcState, setRpcState] = useState<RpcState>({state: 'pending'})

  const {getIdTokenClaims} = useAuth0();

  useEffect(() => {

    let request = BookAppointmentRequest.encode(
        new BookAppointmentRequest({
          businessId: props.businessId,
          appointmentTime: props.appointmentTime,
          serviceId: props.service.sku,
          providerId: props.provider.providerId,
          locationId: props.locationId,
          virtualAppt: props.isVirtual,
          timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
        })
    ).finish()

    SendRpc(getIdTokenClaims, 'book_appointment', request)
        .then(r => {
          let response = BookAppointmentResponse.decode(r);
          console.log('response', JSON.stringify(response.toJSON()));
          if (response.okay && response.appointment) {
            
            // Move onto capture the payment. 
            // TODO: This is async??
            capturePayment(false);
            setRpcState({state: 'success'})
            props.onComplete(response);
            
          } else {
            capturePayment(true);
            setRpcState({state: 'error', message: 'Error booking appointment!'});
          }
        })
        .catch(e => {
          console.warn('Network error capturing payment', e);
          capturePayment(true);
          setRpcState({state: 'error', message: 'Error booking appointment!'});
        });
  }, []);

  // I guess this just gets fired off, it's a best effort thing. If the payment
  // actually is not capture then the provider will get an email and it will be
  // in their dashboard to capture it. 
  const capturePayment = (cancel: boolean) => {

    let request = CapturePaymentRequest.encode(
        new CapturePaymentRequest({
          businessId: props.businessId,
          sessionId: props.sessionId,
          cancel: cancel
        })
    ).finish()
    
    SendRpc(getIdTokenClaims, 'capture_payment', request)
        .then(r => {
          let response = CapturePaymentRequest.decode(r);
          console.log('captured payment', JSON.stringify(response.toJSON()));
        })
        .catch(e => {
          console.warn('captured payment failed', e);
        });
  }
  

  switch (rpcState.state) {
    case "pending":
      return <div>Booking your appointment...</div>

    case 'success':
      return <div>Success</div>;

    case "error":
      return <div>There was an error booking your appointment. Please refresh to start over.</div>

    default:
      return <div>Default state.</div>

  }
}